import { useState } from "react";
import { products, productCategories } from "@/mocks/products";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/pages/home/components/Footer";
import { Link } from "react-router-dom";

export default function Products() {
  const [activeCategory, setActiveCategory] = useState("sve");
  const [searchQuery, setSearchQuery] = useState("");

  const filteredProducts = products.filter((p) => {
    const matchCategory = activeCategory === "sve" || p.categorySlug === activeCategory;
    const matchSearch =
      !searchQuery ||
      p.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      p.shortDesc.toLowerCase().includes(searchQuery.toLowerCase());
    return matchCategory && matchSearch;
  });

  return (
    <main className="min-h-screen bg-white">
      <Navbar />

      <section className="pt-24 md:pt-32 pb-20 md:pb-28 bg-dark-50">
        <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-12">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <span className="inline-block text-dark-400 text-xs font-semibold uppercase tracking-widest mb-4">
                Proizvodi
              </span>
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-dark-900 leading-tight mb-4">
                Kompletna ponuda
              </h1>
              <p className="text-dark-500 text-base sm:text-lg max-w-2xl mx-auto">
                IP kamere, video interfoni, kontrola pristupa, alarmni sistemi — sve na jednom mestu za vašu bezbednost
              </p>
            </div>

            <div className="flex flex-col md:flex-row gap-4 mb-10">
              <div className="relative flex-grow">
                <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-dark-400"></i>
                <input
                  type="text"
                  placeholder="Pretražite proizvode..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-full pl-11 pr-5 py-3.5 rounded-xl border border-dark-200 bg-white text-dark-900 text-sm focus:outline-none focus:border-brand-400 focus:ring-2 focus:ring-brand-100 transition-all"
                />
              </div>
            </div>

            <div className="flex flex-wrap gap-2 mb-12">
              {productCategories.map((cat) => (
                <button
                  key={cat.slug}
                  onClick={() => setActiveCategory(cat.slug)}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                    activeCategory === cat.slug
                      ? "bg-dark-900 text-white"
                      : "bg-white text-dark-600 border border-dark-200 hover:border-dark-300"
                  }`}
                >
                  {cat.name}
                  <span className="ml-1.5 text-xs opacity-60">({cat.count})</span>
                </button>
              ))}
            </div>

            {filteredProducts.length === 0 ? (
              <div className="text-center py-20">
                <div className="w-16 h-16 flex items-center justify-center mx-auto bg-dark-100 rounded-full mb-4">
                  <i className="ri-search-line text-dark-400 text-2xl"></i>
                </div>
                <h3 className="text-lg font-semibold text-dark-900 mb-2">Nema rezultata</h3>
                <p className="text-dark-400">Pokušajte sa drugim terminom pretrage</p>
              </div>
            ) : (
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6" data-product-shop>
                {filteredProducts.map((product, index) => (
                  <Link
                    key={index}
                    to={`/product/${product.id}`}
                    className="group bg-white rounded-2xl border border-dark-100 overflow-hidden transition-all duration-300 hover:-translate-y-2"
                  >
                    <div className="aspect-square bg-dark-50/50 flex items-center justify-center p-6 overflow-hidden">
                      <img
                        src={product.image}
                        alt={product.name}
                        className="w-full h-full object-contain object-center group-hover:scale-105 transition-transform duration-500"
                        loading="lazy"
                      />
                    </div>
                    <div className="p-5">
                      <span className="text-xs font-semibold text-accent-600 uppercase tracking-wider">
                        {product.category}
                      </span>
                      <h3 className="text-base font-bold text-dark-900 mt-1 mb-2 group-hover:text-brand-600 transition-colors">
                        {product.name}
                      </h3>
                      <p className="text-sm text-dark-400 leading-relaxed mb-4 line-clamp-2">
                        {product.shortDesc}
                      </p>
                      <div className="flex items-center justify-between">
                        <span className="text-lg font-bold text-dark-900">{product.price}</span>
                        <span className="w-10 h-10 flex items-center justify-center rounded-full bg-brand-50 text-brand-600 group-hover:bg-brand-500 group-hover:text-white transition-all">
                          <i className="ri-arrow-right-up-line"></i>
                        </span>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            )}
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}